// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"120":"c7f8b54e","889":"aaec6a88"}[chunkId] + ".css";
};